import { CheckCircleOutlined } from '@ant-design/icons'; // Import Ant Design icon
import 'antd/dist/antd.css'; // Ensure Ant Design styles are included
import moment from 'moment';
import React from 'react';

const ReportSubmitted = ({ isDaily, submissionDate }) => {
  return (
    <div className="commodity-form-max-wrapper">
      <div className="box commodity__content w-full max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-8 flex flex-col items-center text-center animate-fade-in">
          {/* Icon */}
          <CheckCircleOutlined
            style={{
              fontSize: '48px',
              color: '#40E0D0', // Turquoise color from Commodity
              marginBottom: '16px',
            }}
          />

          {/* Heading */}
          <h2
            className="text-black-bold-f19-l33 text-2xl font-bold text-gray-800 mb-4"
            style={{ color: '#2D1B4E' /* Purple-dark from Commodity */ }}
          >
            {isDaily ? 'Добовий звіт уже подано' : 'Місячний звіт уже подано'}
          </h2>

          {/* Message */}
          <p
            className="text-grey-normal-f16-l28 text-lg text-gray-600"
            style={{ lineHeight: '28px' }}
          >
            Звіт за{' '}
            <span className="font-semibold">
              {isDaily
                ? moment(submissionDate).format('DD.MM.YYYY')
                : moment(submissionDate).locale('uk').format('MMMM YYYY')}
            </span>{' '}
            було надіслано.
            <br />
            Новий звіт можна буде подати{' '}
            <span className="font-semibold">
              {isDaily ? 'завтра' : moment().endOf('month').add(1, 'day').format('DD.MM.YYYY')}
            </span>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReportSubmitted;
